import { Attribute, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Router, RouterLink, RouterLinkWithHref } from '@angular/router';
import { SgAuxRouteCommandLike } from './models';
import { SgAuxRouter } from './aux-router.service';

function isSgAuxRouteCommandLike(commands: any[] | string | SgAuxRouteCommandLike): commands is SgAuxRouteCommandLike {
  return commands && !(typeof commands === 'string' || Array.isArray(commands));
}

function getRouterLink(auxRouter: SgAuxRouter, commands: any[] | string | SgAuxRouteCommandLike): string | any[] {
  if (isSgAuxRouteCommandLike(commands)) {
    const { outlet, path, options } = commands;
    return auxRouter.getRouteCommand(outlet, path, options || {});
  } else {
    return commands;
  }
}

@Directive({
  selector: ':not([routerLink]):not(a)[sgAuxRouterLink]',
  standalone: false,
})
export class SgAuxRouterLinkDirective extends RouterLink {
  private auxCommands?: SgAuxRouteCommandLike;

  @Input('sgAuxRouterLink') set sgAuxRouterLink(commands: any[] | string | SgAuxRouteCommandLike) {
    this.routerLink = getRouterLink(this.auxRouter, commands);
    this.auxCommands = isSgAuxRouteCommandLike(commands) ? commands : undefined;
  }

  constructor(
    private auxRouter: SgAuxRouter,
    router: Router,
    @Attribute('tabindex') tabIndex: string,
    renderer: Renderer2,
    el: ElementRef
  ) {
    super(router, router.routerState.root, tabIndex, renderer, el);
  }

  onClick(
    button: number = 0,
    ctrlKey: boolean = false,
    shiftKey: boolean = false,
    altKey: boolean = false,
    metaKey: boolean = false
  ): boolean {
    if (this.auxCommands) {
      const { outlet, path } = this.auxCommands;
      this.auxRouter.autoClearNextNavigation(outlet, path);
    }
    return super.onClick(button, ctrlKey, shiftKey, altKey, metaKey);
  }
}

@Directive({
  selector: ':not([routerLink])a[sgAuxRouterLink]',
  standalone: false,
})
export class SgAuxRouterLinkWithHrefDirective extends RouterLinkWithHref {
  private auxCommands?: SgAuxRouteCommandLike;

  @Input('sgAuxRouterLink') set sgAuxRouterLink(commands: any[] | string | SgAuxRouteCommandLike) {
    this.routerLink = getRouterLink(this.auxRouter, commands);
    this.auxCommands = isSgAuxRouteCommandLike(commands) ? commands : undefined;
  }

  constructor(
    private auxRouter: SgAuxRouter,
    router: Router,
    locationStrategy: LocationStrategy,
    @Attribute('tabindex') tabIndexAttribute: string | null | undefined,
    renderer: Renderer2,
    el: ElementRef
  ) {
    super(router, router.routerState.root, tabIndexAttribute, renderer, el, locationStrategy);
  }
}
